import { ProfileEffects } from './containers/profile/profile.effects'
import { SearchResultsEffects } from './containers/search-results/search-results.effects'
import { DashboardEffects } from './containers/dashboard/dashboard.effects'
import { MapEffects } from './containers/map/map.effects'
import { FixedTemplatesEffects } from './containers/fixed-templates/fixed-templates.effects'
import { PaymentPurposesEffects } from './containers/payment-purposes/payment-purposes.effects'
import { FinancialInstitutionsEffects } from './containers/financial-institutions/financial-institutions.effects'
import { RolesEffects } from './containers/roles/roles.effect'
import { BusinessesEffects } from './containers/businesses/businesses.effects'
import { PdfBatchGenerationEffects } from './containers/pdf-batch-generation/pdf-batch-generation.effects'
import { PropertyTypeTemplatesEffects } from './containers/property-type-templates/property-type-templates.effects'
import { SettingsEffects } from './containers/settings/settings.effects'
import { DataCyclesEffects } from './containers/data-cycles/data-cycles.effects'
import { TemplatesEffects } from './containers/templates/templates.effects'
import { PropertiesEffects } from './containers/properties/properties.effects'
import { IndustriesEffects } from './containers/industries/industries.effects'
import { OrganizationsEffects } from './containers/organizations/organizations.effects'
import { ContactTitlesEffects } from './containers/contact-titles/contact-titles.effects'
import { CommunitiesEffects } from './containers/communities/communities.effects'
import { ImageTypesEffects } from './containers/image-types/image-types.effects'
import { StreetTypesEffects } from './containers/street-types/street-types.effects'
import { StreetsEffects } from './containers/streets/streets.effects'
import { SharedEffects } from './shared/shared.effects'
import { UsersEffects } from './containers/users/users.effects'
import { AuthEffects } from './containers/auth/auth.effects'
import { ContactTypesEffects } from './containers/contact-types/contact-types.effects'
import { FormsEffects } from './containers/forms/forms.effects'
import { DocumentTypesEffects } from './containers/document-types/document-types.effects'
import { CommercialLicenseMappingsEffects } from '@containers/commercial-license-mappings/commercial-license-mappings.effects'
import { AuditLogsEffects } from '@containers/audit-logs/audit-logs.effects'
import { ReportsEffects } from '@containers/reports/reports.effect'
import { WardsEffects } from '@containers/wards/wards.effects'
import { DiscountGroupsEffects } from '@containers/discount-groups/discount-groups.effects'
import { I18nEffectsService } from '@containers/i18n/store/i18n-effects.service'
import { LanguagesEffectsService } from '@containers/languages/store/languages.service'
import { BusinessCategoriesEffects } from '@containers/business-categories/business-categories.effects'
import { SystemSettingsEffects } from '@containers/system-settings/system-settings.effects'
import { SecuritySettingsEffects } from '@containers/security-settings/security-settings.effects'
import { SmtpSettingsEffects } from '@containers/smtp-settings/smtp-settings.effects'
import { GisSettingsEffects } from '@containers/gis-settings/gis-settings.effects'
import { PathSettingsEffects } from '@containers/path-settings/path-settings.effects'
import { DigitizationEffects } from '@containers/digitization/digitization.effects'
import { UnitsSettingsEffects } from '@containers/units-settings/units-settings.effects'
import { LayerEffects } from '@containers/layer/layer.effects'
import { MobileUsersEffects } from '@containers/mobile-users/mobile-users.effects'
import { MobileSettingsService } from '@containers/mobile-settings/mobile-settings.service'
import { MobileSettingsEffects } from '@containers/mobile-settings/mobile-settings.effects'
import { StaticContentTemplatesEffects } from '@containers/static-content-templates/static-content-templates.effects'
import { MobileTasksEffects } from '@containers/mobile-tasks/mobile-tasks.effects'
import { LicenseGenerationSettingsEffects } from '@containers/license-generation-settings/license-generation-settings.effects'
import { UISettingsEffects } from '@containers/ui-settings/ui-settings.effects'
import { CompoundsEffects } from '@containers/compounds/compounds.effects'
import { LicenseTypesEffects } from '@containers/license-types/license-types.effects'
import { NotDeliveredReasonEffects } from '@containers/not-delivered-reason/not-delivered-reason.effects'
import { ExternalDashboardsSettingsEffects } from '@containers/external-dashboard-settings/external-dashboard-settings.effects'
import { FormPostprocessorsEffects } from '@containers/form-postprocessors/form-postprocessors.effects'
import { CompoundSettingsEffects } from '@containers/compound-settings/compound-settings.effects'
import { MapAnalyticsEffects } from '@containers/map-analytics/map-analytics.effects'

const effects = [
  AuthEffects,
  UsersEffects,
  SharedEffects,
  StreetsEffects,
  StreetTypesEffects,
  ContactTypesEffects,
  ImageTypesEffects,
  FormsEffects,
  CommunitiesEffects,
  ContactTitlesEffects,
  OrganizationsEffects,
  IndustriesEffects,
  PropertiesEffects,
  TemplatesEffects,
  DataCyclesEffects,
  PropertyTypeTemplatesEffects,
  SettingsEffects,
  PdfBatchGenerationEffects,
  DocumentTypesEffects,
  BusinessesEffects,
  RolesEffects,
  FinancialInstitutionsEffects,
  PaymentPurposesEffects,
  CommercialLicenseMappingsEffects,
  AuditLogsEffects,
  FixedTemplatesEffects,
  ReportsEffects,
  MapEffects,
  DashboardEffects,
  WardsEffects,
  SearchResultsEffects,
  DiscountGroupsEffects,
  ProfileEffects,
  I18nEffectsService,
  LanguagesEffectsService,
  BusinessCategoriesEffects,
  SystemSettingsEffects,
  SecuritySettingsEffects,
  SmtpSettingsEffects,
  GisSettingsEffects,
  PathSettingsEffects,
  UnitsSettingsEffects,
  DigitizationEffects,
  LayerEffects,
  MobileUsersEffects,
  MobileSettingsEffects,
  StaticContentTemplatesEffects,
  MobileTasksEffects,
  LicenseGenerationSettingsEffects,
  UISettingsEffects,
  CompoundsEffects,
  LicenseTypesEffects,
  NotDeliveredReasonEffects,
  ExternalDashboardsSettingsEffects,
  FormPostprocessorsEffects,
  CompoundSettingsEffects,
  MapAnalyticsEffects,
]

export { effects }
